module.exports = __webpack_public_path__ + "static/Apercu-Mono-Pro-52dfaf740a8b92e7eb8b011c42c5e4bd.otf";